<div class="accessibility-component">
  <p-card>
    <div class="accessibility-container">
      <img class="background-image" src="assets/odot-heb.svg" alt="">
      <div class="section">
        <h2 class="title">הצהרת נגישות לאתר IAA.ORG.IL</h2>
        <p class="update-date">תאריך עדכון: 07/05/2023</p>
      </div>

      <div class="section intro">
        <p>
          רשות העתיקות היא רשות ממלכתית והמוסד המקצועי לאומי בארכיאולוגיה של ארץ ישראל. רשות העתיקות אחראית על עתיקות הארץ ועל אתרי העתיקות; על חשיפתם, שמירתם, שימורם, חקירתם, הצגתם, פרסומם, ועל ניהול אוצרות העתיקות במדינת ישראל. אחד מהיעדים המרכזיים של רשות העתיקות הוא לקרב את הציבור לנכסי העבר ולמורשתו. רשות העתיקות רואה חשיבות רבה במתן אפשרות שווה ונגישה לשימוש במידע המצוי באתר לאנשים עם מוגבלויות.
        </p>
      </div>

      <div class="section commitment">
        <p class="highlight">
          רשות העתיקות מחויבת ליצירת חוויית שירות חיובית לכלל לקוחותיה בכל ערוצי הפעילות. בהתאם למחויבות זו ובהתאם להוראות חוק שוויון זכויות לאנשים עם מוגבלות, תשנ"ח-1998, ותקנותיו, מבצעת רשות העתיקות התאמות נגישות באתר האינטרנט שלה בליוויי יועצי נגישות ועוד גורמים מקצועיים, על מנת לאפשר שירות מלא, מהיר ויעיל באמצעות אתר האינטרנט גם ללקוחות עם מוגבלות.
        </p>
      </div>

      <div class="section">
        <h2>הסדרי נגישות בסניפים</h2>
        <p>
          מתקני רשות העתיקות מונגשים בהתאם לחוק עבור בעלי מוגבלויות. רשות העתיקות מקפידה להנגיש כל מתקן בהתאם לתקן התקף למען עובדיה ולמען מבקרים במתקנים קולטי קהל. אתרי חפירה ושימור של הרשות מוגדרים כאתרי עבודת בניה וככאלו אינם מונגשים.
        </p>
      </div>

      <div class="section wide">
        <h2>להלן טבלה מרכזת בנושא:</h2>
        <div class="table-container">
          <table class="accessibility-table">
            <thead>
              <tr>
                <th>מבנה / סניף</th>
                <th>כתובת</th>
                <th>מערכת שמע לכבדי שמיעה</th>
                <th>שירותי נכים</th>
                <th>כניסה נגישה</th>
                <th>ריהוט נגיש</th>
                <th>שילוט</th>
                <th>חניית נכים</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>בקריה הלאומית לארכיאולוגיה של ארץ ישראל ע"ש ג'יי וג'יני שוטנשטיין</td>
                <td>רח' נחמן אביגד 1, ירושלים</td>
                <td><i class="pi pi-check"></i></td>
                <td><i class="pi pi-check"></i></td>
                <td><i class="pi pi-check"></i></td>
                <td><i class="pi pi-check"></i></td>
                <td><i class="pi pi-check"></i></td>
                <td><i class="pi pi-check"></i></td>
              </tr>
              <tr>
                <td>מרחב צפון - נהלל</td>
                <td>סמוך למשטרת נהלל ההיסטורית</td>
                <td><i class="pi pi-check"></i></td>
                <td><i class="pi pi-check"></i></td>
                <td><i class="pi pi-check"></i></td>
                <td><i class="pi pi-check"></i></td>
                <td><i class="pi pi-check"></i></td>
                <td><i class="pi pi-check"></i></td>
              </tr>
              <tr>
              <tr>
                <td>מרחב מרכז - שוהם</td>
                <td>רחוב האורן 4, הייפורט, אזור התעשייה שוהם</td>
                <td><i class="pi pi-check"></i></td>
                <td><i class="pi pi-check"></i></td>
                <td><i class="pi pi-check"></i></td>
                <td><i class="pi pi-check"></i></td>
                <td><i class="pi pi-check"></i></td>
                <td><i class="pi pi-check"></i></td>
              </tr>
              <tr>
                <td>מרחב מרכז - אור עקיבא</td>
                <td>רחוב האילן 14, אור עקיבא</td>
                <td><i class="pi pi-check"></i></td>
                <td><i class="pi pi-check"></i></td>
                <td><i class="pi pi-check"></i></td>
                <td><i class="pi pi-check"></i></td>
                <td><i class="pi pi-check"></i></td>
                <td><i class="pi pi-check"></i></td>
              </tr>
              <tr>
                <td>מרחב צפון - עכו</td>
                <td>רחוב בן עמי 10, עכו</td>
                <td><i class="pi pi-check"></i></td>
                <td><i class="pi pi-check"></i></td>
                <td><i class="pi pi-check"></i></td>
                <td><i class="pi pi-check"></i></td>
                <td><i class="pi pi-check"></i></td>
                <td><i class="pi pi-check"></i></td>
              </tr>
              <tr>
                <td>מרחב דרום - עומר</td>
                <td>מבנה 3D, גן תעשייה עומר</td>
                <td><i class="pi pi-check"></i></td>
                <td><i class="pi pi-check"></i></td>
                <td><i class="pi pi-check"></i></td>
                <td><i class="pi pi-check"></i></td>
                <td><i class="pi pi-check"></i></td>
                <td><i class="pi pi-check"></i></td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <div class="section">
        <h2>שירות לקוחות נגיש</h2>
        <ul class="service-list">
          <li>כל עובדי הארגון אשר מעניקים שירות ללקוחות, עברו הדרכה והכשרה בהיבטים של מתן שירות לאנשים עם מוגבלות</li>
          <li>מבני הרשות אשר מקבלים קהל מונגשים.</li>
          <li>בכל יחידה המקבלת קהל יש מערכות עזר לשמיעה עם לולאת השראה</li>
          <li>המענה הקולי הונגש כך שהמידע מוקלט בשפה ברורה וללא מוסיקת רקע.</li>
        </ul>
      </div>

      <div class="section">
        <h2>אתר אינטרנט נגיש</h2>
        <p>
          בוצעו התאמות נגישות באתר האינטרנט באופן שיאפשר לאנשים עם מוגבלות ולאנשים מבוגרים לגלוש באותה רמה של יעילות והנאה ככל הגולשים.

האתר עומד בדרישות תקנות שיוויון זכויות לאנשים עם מוגבלות (התאמות נגישות לשירות), התשע"ג 2013 והותאם לפי המלצות התקן הישראלי (ת"י 5568).
בוצעה התאמה לדרישות הנגישות של ארגון W3C לרמה 2 (AA) ונבנה לפי התקן של W3C ל- CSS ו .HTML.
האתר מותאם לתצוגה בדפדפנים שונים (כרום, מוזילה, edge), לרבות שימוש בטלפון הסלולרי. אתר האינטרנט נבדק בקרא מסך מסוג NVDA בגרסתו העדכנית ביותר.
        </p>
      </div>

      <div class="section">
        <h2>נתקלתם בבעיה? ספרו לנו</h2>
        <ul class="service-list">
          <li>תיאור הבעיה.</li>
          <li>סוג וגרסה של הדפדפן.</li>
          <li>מערכת הפעלה.</li>
          <li>סוג הטכנולוגיה המסייעת (במידה והשתמשתם).</li>
          <li>באיזה דף גלשתם?</li>
          <li>מהי הפעולה שניסיתם לבצע?</li>
          <li>אנחנו נטפל בבעיה ונחזור אליך בהקדם עם פרטים על טיפולה.</li>
        </ul>
      </div>

      <div class="section contact-info">
        <h2>פרטי קשר רכז הנגישות</h2>
        <p><strong>הממונה על נושא נגישות: מר ידידיה זלינגר</strong></p>
        <div class="contact-details">
          <p>כתובת: הקריה הלאומית לארכיאולוגיה של ארץ ישראל, רח' נחמן אביגד 1, ירושלים, מיקוד 9370726</p>
          <p>טלפון: 073-3507059</p>
          <p>
            <a href="mailto:mokediaa@israntique.org.il">{{'mokediaa@israntique.org.il'}}</a>
          </p>
          <p>
            ניתן לפנות בכל שאלה ובקשה לעניין הנגישות באמצעות <a [routerLink]="[]" [queryParams]="{pageId: 2}">דף יצירת קשר</a>
          </p>
        </div>
      </div>
    </div>
  </p-card>
</div>